import styled from 'styled-components'

import { Box, Button, Flex } from 'app/components/design-system-components'
import { theme } from 'app/match/applicationReportPDF/assets/theme'

interface InvestDashboardTileProps {
  text: React.ReactNode
  onClick: () => void
  image: string
  textStrong?: React.ReactNode
  textDesc?: React.ReactNode
  buttonText?: string
  buttonGTMClassName?: string
  buttonDisabled?: boolean
}

const StyledStrong = styled.strong`
  font-size: ${theme.fontSizes.pExtraLarge18};
`

const InvestDashboardTile: React.FC<InvestDashboardTileProps> = ({
  text,
  textStrong,
  onClick,
  image,
  textDesc,
  buttonText = '',
  buttonGTMClassName,
  buttonDisabled = false,
}) => {
  const investDashboardText = (
    <Box lineHeight="140%">
      <Box mt={7}>
        <StyledStrong>{textStrong}</StyledStrong>
        <Box my={6}>{textDesc}</Box>
      </Box>
    </Box>
  )
  return (
    <li className="renter-dashboard-li">
      <Box width="100%" height="100%">
        <Box>
          <Flex justifyContent="space-between" alignItems="center">
            <img
              src={image}
              style={{ maxWidth: `${theme.width[12]}px` }}
              alt="agency logo"
            />
            <Box textAlign="right" fontSize={theme.fontSizes.pRegular14}>
              {text}
            </Box>
          </Flex>
          {investDashboardText}
          <Box mt={5}>
            <Button
              p={4}
              sizeVariant="large"
              width="100%"
              onClick={onClick}
              className={buttonGTMClassName}
              disabled={buttonDisabled}
            >
              {buttonText}
            </Button>
          </Box>
        </Box>
      </Box>
    </li>
  )
}

export default InvestDashboardTile
